import React, {useCallback, useEffect, useState} from 'react';
import Container from 'react-bootstrap/Container';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Table, Modal } from 'antd';
import { Button } from 'react-bootstrap';
import AddImage from './AddImage';
import Swal from 'sweetalert2';
import { useAdminClient } from "hooks/useAdminClient";

const {confirm} = Modal;

const ImageList = () => {
  const client = useAdminClient();
  const [showModal, setShowModal] = useState(false);
  const [images, setImages] = useState([]);
  const [totalArticleCount, setTotalArticleCount] = useState();
  const [page, setPage] = useState(1)
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Preview Banner',
      key: 'img',
      render: (row) => { 
        return (<img src={`${process.env.REACT_APP_API_HOST}${row.img}`} alt="Preview" width="200" />);
      },
    },
    {
      title: 'Image url',
      dataIndex: 'img',
      key: 'img',
      render: (row) => { 
        return `${process.env.REACT_APP_API_HOST}${row}`;
      },
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'x',
      render: (row) => 
        <div style={{display: 'flex'}}>
          <Button
            variant='danger'
            onClick={() => handleDelete(row.id)}
          >Delete</Button>,
        </div>
    },
  ];

  const handleClose = () => {
    setShowModal(false)
  }

  const handleDelete = (rowId) => {
    confirm({
      title: 'Do you want to delete this image?',
      icon: <ExclamationCircleFilled />,
      content: `Id: ${rowId}`,
      async onOk() {
        await client.delete(`/be/api/v1/images/delete/${rowId}`);
        fetchData()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Delete image success",
          showConfirmButton: false,
          timer: 1500
        });
        console.log('OK');
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const fetchData = useCallback(async (params)  => {
    const queryParams = new URLSearchParams();
    queryParams.set('page', page)
    const response = await client.get(`/be/api/v1/images/getList?${queryParams}`);
    const {images: data, totalCount} = response.data;
    
    setImages(data);
    setTotalArticleCount(totalCount);
  }, [page])
  useEffect(() => {
    fetchData();
  }, [page])
	return (
    <div>
      <Container style={{flex: 'auto'}}>
        <div style={{display: 'flex', flex: 'auto', margin: '10px'}}>
          <h1>Image List</h1>
          <Button
            style={{marginLeft: 'auto'}}
            onClick={() => setShowModal(true)}
          >Add Image</Button>

        </div>
        <Table
          columns={columns}
          dataSource={images}
          page={12}
          pagination={{
            total: totalArticleCount,
            onChange: (page) => setPage(page)
          }}
        />
      </Container>
      <AddImage
        showModal={showModal}
        setShowModal={setShowModal}
        handleClose={handleClose}
        fetchData={fetchData}
      />
    </div>
	);
};

export default ImageList